Chart.pluginService.register({
	beforeRender: function (chart) {
		if (chart.config.options.showAllTooltips) {
			// create an array of tooltips
			// we can't use the chart tooltip because there is only one tooltip per chart
			chart.pluginTooltips = [];
			chart.config.data.datasets.forEach(function (dataset, i) {
				chart.getDatasetMeta(i).data.forEach(function (sector, j) {
					chart.pluginTooltips.push(
						new Chart.Tooltip(
							{
								_chart: chart.chart,
								_chartInstance: chart,
								_data: chart.data,
								_options: chart.options.tooltips,
								_active: [sector],
							},
							chart
						)
					);
				});
			});

			// turn off normal tooltips
			chart.options.tooltips.enabled = false;
		}
	},
	afterDraw: function (chart, easing) {
		if (chart.config.options.showAllTooltips) {
			// we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
			if (!chart.allTooltipsOnce) {
				if (easing !== 1) return;
				chart.allTooltipsOnce = true;
			}

			// turn on tooltips
			chart.options.tooltips.enabled = true;
			Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
				tooltip.initialize();
				tooltip.update();
				// we don't actually need this since we are not animating tooltips
				tooltip.pivot();
				tooltip.transition(easing).draw();
			});
			chart.options.tooltips.enabled = false;
		}
	},
});

jQuery(document).ready(function ($) {
	var fontFamily = 'Work Sans';
	var selectedIndex = false;
	var defaultColors = [
		'#4c209e',
		'#8a41d9',
		'#ed8a9c',
		'#88dfbf',
		'#f9bac6',
		'#d6fff0',
		// Repeat
		'#4c209e',
		'#8a41d9',
		'#ed8a9c',
		'#88dfbf',
		'#f9bac6',
		'#d6fff0',
		// Repeat
		'#4c209e',
		'#8a41d9',
		'#ed8a9c',
		'#88dfbf',
		'#f9bac6',
		// Removed last color to prevent same color next to each other

		// '#2988ce',
		// '#1e669b',
		// '#144467',
		// '#a7d0ee',
		// '#7ab8e5',
		// '#2988ce',
		// '#1e669b',
		// '#144467',
		// '#a7d0ee',
		// '#7ab8e5',
		// '#2988ce',
		// '#1e669b',
		// '#144467',
		// '#a7d0ee'
	];
	var defaultBarColors = {
		blue: ['#8a41d9', '#4c209e'],
	};

	$('.chart.bar').each(function () {
		var ctx = document.getElementById($(this).attr('id')).getContext('2d');

		var data = {
			labels: $.parseJSON($(this).attr('data-horizontal-axis-labels')),
			datasets: $.parseJSON($(this).attr('data-datasets')),
		};

		var options = {
			cornerRadius: 0,
			cornerRadiusTopLeft: 4,
			cornerRadiusTopRight: 4,

			barValueSpacing: 57,
			responsive: false,
			width: 1200,
			height: 400,
			legend: false,
			showAllTooltips: true,
			layout: {
				padding: {
					left: 0,
					right: 0,
					top: 45,
					bottom: 0,
				},
			},
			scales: {
				xAxes: [
					{
						gridLines: {
							display: false,
						},
						ticks: {
							autoSkip: false,
							fontColor: '#232323',
							fontFamily: fontFamily,
							fontSize: 20,
							display: true,
							maxRotation: 0,
							minRotation: 0,
							fontWeight: 400,
							callback: function (value, index, values) {
								return value.split(' ');
							},
						},
					},
				],
				yAxes: [
					{
						gridLines: {
							display: true,
							drawBorder: false,
							offsetGridLines: false,
						},
						ticks: {
							display: true,
							beginAtZero: true,
							fontFamily: fontFamily,
							fontColor: '#232323',
							fontSize: 20,
							padding: 8,
						},
						scaleLabel: {
							display: true,
							fontSize: 20,
							fontColor: '#232323',
							labelString: $(this).attr('data-vertical-axis-label'),
							yPadding: 10,
						},
					},
				],
			},
			tooltips: {
				callbacks: {
					title: function (tooltipItem, data) {
						return data['datasets'][tooltipItem[0]['datasetIndex']]['label'];
					},
					label: function (tooltipItem, data) {
						return data['datasets'][tooltipItem['datasetIndex']]['data'][
							tooltipItem['index']
						].replace('.', ',');
					},
				},

				backgroundColor: 'rgba(0,0,0,0)',
				titleFontSize: 0,
				titleFontStyle: 'normal',
				titleFontFamily: fontFamily,
				titleFontColor: '#6e6e6e',
				titleAlign: 'center',
				bodyFontSize: 20,
				bodyFontStyle: 'normal',
				bodyFontFamily: fontFamily,
				bodyFontColor: '#232323',
				bodyAlign: 'center',
				xPadding: 0,
				yPadding: 4,
				xAlign: 'center',
				yAlign: 'bottom',
				displayColors: false,
			},
		};

		var myBarChart = new Chart(ctx, {
			type: 'bar',
			data: data,
			options: options,
		});
		var $legendID = 'legend-' + $(this).attr('id');
		document.getElementById($legendID).innerHTML = myBarChart.generateLegend();
	});

	/* Based off of: http://jsfiddle.net/nkzyx50o/ */
	Chart.pluginService.register({
		beforeDraw: function (chart) {
			if (chart.config.options.elements.center) {
				//Get ctx from string
				var ctx = chart.chart.ctx;

				//Get options from the center object in options
				var centerConfig = chart.config.options.elements.center;
				var fontStyle = centerConfig.fontStyle || 'Arial';
				ctx.fontWeight = '300';

				//Set font settings to draw it correctly.
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';
				var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
				var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

				var lastActive = chart.lastActive[0];
				if (typeof lastActive === 'undefined') {
					var color = '#6e6e6e';
					var labelFontSize =
						ctx.canvas.dataset.donutLargeInactiveLabel === 'true' ? '40px' : '18px';
					ctx.font = labelFontSize + ' ' + fontStyle;
					ctx.fillStyle = color;
					ctx.fillText(ctx.canvas.dataset.donutInactiveLabel, centerX, centerY);
					return;
				}

				var currDataset = chart.chart.getDatasetMeta(lastActive._datasetIndex);
				var currLabel = currDataset.data[lastActive._index]._model.label;
				var currValue = chart.chart.data.datasets[0].data[lastActive._index];
				if (ctx.usesPercentage === 'true') {
					currValue += '%';
				}

				var color = '#6e6e6e';
				ctx.font = '14px ' + fontStyle;
				ctx.fillStyle = color;
				ctx.fillText(currLabel.toUpperCase(), centerX, centerY - 20);

				var color = '#232323';
				ctx.font = '32px ' + fontStyle;
				ctx.fillStyle = color;
				ctx.fillText(currValue, centerX, centerY + 20);
			}
		},
	});

	$('.chart.pie').each(function () {
		var ctx = document.getElementById($(this).attr('id')).getContext('2d');
		ctx.usesPercentage = $(this).attr('data-uses-percentage');

		var options = {
			responsive: false,
			width: 300,
			height: 300,
			cutoutPercentage: 71,
			legend: {
				display: false,
			},
			tooltips: {
				display: false,
				enabled: false,
			},
			elements: {
				center: {
					color: '#232323',
					fontStyle: 'Work Sans',
				},
			},
			onHover: function (evt, elements) {
				if (elements && elements.length) {
					var segment = elements[0];
					if (selectedIndex !== segment['_index']) {
						this.chart.update();
						selectedIndex = segment['_index'];
						segment._model.outerRadius += 8;
					} else {
						selectedIndex = null;
					}
				} else {
					this.chart.update();
				}
			},
			layout: {
				padding: 30,
			},
		};

		var data = {
			datasets: [
				{
					data: $.parseJSON($(this).attr('data-pie-values')),
					backgroundColor: defaultColors,
					hoverBorderColor: defaultColors,
					hoverBackgroundColor: defaultColors,
					borderWidth: 0,
					hoverBorderWidth: 0,
					radius: 0,
					pointHoverRadius: 0,
				},
			],
			labels: $.parseJSON($(this).attr('data-pie-labels')),
		};

		var myDoughnutChart = new Chart(ctx, {
			type: 'doughnut',
			data: data,
			options: options,
		});
	});

	var sliderResizeTimeout = false;
	var resizeGraphSlider = function (slider) {
		var slide = slider.find('.slick-active');
		slider.find('.slide').animate({ height: slide.find('.inner-wrapper').height() + 50 }, 150);
	};

	$('.graphs-slider').each(function () {
		var sliderElement = $(this);
		sliderElement.slick({
			dots: true,
			arrows: false,
			autoplay: false,
			adaptiveHeight: false,
			infinite: true,
			draggable: false,
			swipe: false,
			cssEase: 'linear',
		});
		sliderElement.on('afterChange', function (event, slick, currentSlide) {
			clearTimeout(sliderResizeTimeout);
			sliderResizeTimeout = setTimeout(
				function (slider) {
					resizeGraphSlider(slider);
				},
				500,
				$(this)
			);
		});
		resizeGraphSlider(sliderElement);
	});

	$(document).on('click', '.advance-slick-slider', function (e) {
		e.preventDefault();
		var slider = $(this)
			.closest('.flexible-content, .flexible-content-text-page')
			.find('.graphs-slider');
		if ($(this).hasClass('next')) {
			slider.slick('slickNext');
		} else {
			slider.slick('slickPrev');
		}
	});
});
